import React from 'react';
import styles from './PageContent.module.css';

interface PageContentProps {
  children: React.ReactNode;
  className?: string;
}

const PageContent: React.FC<PageContentProps> = ({ children, className }) => {
  return (
    <div className={`${styles.pageContent} ${className || ''}`}>
      {children}
    </div>
  );
};

export default PageContent;
